import { Plane } from 'lucide-react';

const Type1TopBanner = (props) => {

    const {
        bookingEngine,
        flights,
        filteredFlights,
    } = props;

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
        });
    };

    let CABIN_CLASS="";
    let ORIGIN_CITY="";
    let ORIGIN_CITY_CODE="";
    let ORIGIN_IATA="";
    let DESTINATION_CITY="";
    let DESTINATION_IATA="";
    let DESTINATION_CITY_CODE="";
    let TRAVEL_DATES="";
    let PASSENGERS=[];
    let is_one_way=true;

    if(Array.isArray(flights) && flights.length > 1){
        const flight = flights?.[0];
        const {
            total_amount, 
            total_currency, 
            slices, 
            owner, 
            conditions, 
            available_services, 
            passengers 
        } = flight;

        PASSENGERS=passengers;

        CABIN_CLASS = slices[0]?.segments[0]?.passengers[0]?.cabin?.marketing_name;
        const SEGMENT_LENGTH = slices[0]?.segments?.length;
        ORIGIN_CITY = slices[0].segments[0]?.origin?.city_name;
        DESTINATION_CITY = slices[0]?.segments[(SEGMENT_LENGTH - 1)]?.destination?.city_name;
        ORIGIN_IATA = slices[0]?.segments[0]?.origin?.iata_code;
        ORIGIN_CITY_CODE = slices[0]?.segments[0]?.origin.iata_city_code
        DESTINATION_IATA = slices[0]?.segments[(SEGMENT_LENGTH - 1)]?.destination?.iata_code;
        DESTINATION_CITY_CODE = slices[0]?.segments[(SEGMENT_LENGTH - 1)]?.destination.iata_city_code;
        TRAVEL_DATES=formatDate(slices?.[0]?.segments?.[0]?.departing_at);

        if(slices.length>1){
            const LAST_SLICE_SEG_LENGTH=slices[(slices.length-1)]?.segments?.length;
            if(ORIGIN_CITY===slices[(slices.length-1)]?.segments[LAST_SLICE_SEG_LENGTH-1]?.destination?.city_name){
                is_one_way=false;
                TRAVEL_DATES=(formatDate(slices?.[0]?.segments?.[0]?.departing_at)+" • "+formatDate(slices[(slices.length-1)]?.segments[LAST_SLICE_SEG_LENGTH-1]?.departing_at));
            }
        }
    }

    return <div style={{ 
            background: 'linear-gradient(to right, #0f172a, #1e3a8a, #0f172a)', 
            color: 'white', 
            padding: '48px 24px',
            marginTop: 10,
            marginBottom: 10,
            /*boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'*/
        }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <div style={{ 
                backgroundColor: ((bookingEngine?.actionButtonsBg+"33") || 'rgba(255, 255, 255, 0.1)'), 
                backdropFilter: 'blur(8px)',
                padding: '12px', 
                borderRadius: '12px' 
            }}>
                <Plane style={{ height: '32px', width: '32px', color: `${bookingEngine?.actionButtonsBg} !important` }} />
            </div>
            <div>
                <h1 style={{ fontSize: '36px', fontWeight: 'bold', letterSpacing: '-0.025em', color: bookingEngine?.actionButtonsBg }}>
                    Flight Search Results
                </h1>
                <p style={{ color: '#bfdbfe', marginTop: '4px' }}>
                    {ORIGIN_CITY} ({ORIGIN_IATA}) → {DESTINATION_CITY} ({DESTINATION_IATA})</p>
            </div>
            </div>
            <p style={{ color: (bookingEngine?.actionButtonsBg || '#cbd5e1'), marginTop: '8px', opacity: 0.9 }}>
            {(filteredFlights?.length || flights.length)} {
                (filteredFlights?.length) ?
                    ((filteredFlights.length === 1) ? 'flight' : 'flights') :
                    ((flights.length === 1) ? 'flight' : 'flights')
            } found
            </p>
        </div>
    </div>
}

export default Type1TopBanner;

